<div class="row">
    <div class="col-24">
        <h3>Training & Certifications </h3>
    </div>
</div>
<div class="row">
    <div class="col-24">
        <table *ngIf='showcourses' class="table-striped table-hover custom-table">
            <tr>
                <th>CourseID</th>
                <th>Course Name</th>
                <th>LastAccess</th>
                <th>Completed Date</th>
                <th> Status</th>
            </tr>
            <tr *ngFor="let x of userCoursesViewModel">
                <td>{{x.CourseID}}</td>
                <td>{{x.CourseName}}</td>
                <td>{{x.LastAccess | date : "MMM d, y h:mm "}}</td>
                <td>{{x.CompletionDate| date : "MMM d, y h:mm "}}</td>
                <td>{{x.Status}}</td>
            </tr>
        </table>
    </div>
</div>
<div *ngIf='showcoursemsg'>
    <label Font-Bold="true" ForeColor="Red">No curriculums or courses have been specified for your hierarchy.</label>
</div>



